import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';

import { Room } from '@era/locations-sdk';
import { Subscription } from 'rxjs';

@Component({
  selector: 'era-room-select-ui',
  templateUrl: './room-select.component.html',
  styleUrls: ['./room-select.component.scss'],
  imports: [ReactiveFormsModule],
})
export class RoomSelectComponent implements OnInit, OnChanges, OnDestroy {
  readonly selectRoom = new UntypedFormControl('');

  @Input() rooms: Room[];
  room: Room;

  @Output() readonly roomChange = new EventEmitter<Room>();

  private readonly subscriptions: Subscription[] = [];

  ngOnInit() {
    this.subscriptions.push(
      this.selectRoom.valueChanges.subscribe((room) => {
        this.roomChange.emit(room);
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rooms) {
      // when rooms is set, then set the depicted default (rooms[0]) as the default room
      if (this.rooms !== null && this.rooms.length > 0) {
        this.selectRoom.setValue(this.rooms[0]);
      }
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (!subscription.closed) {
        subscription.unsubscribe();
      }
    });
  }
}
